<template>
  <div>
    <header>追溯网址</header>

    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <section v-else class="box">

      <!-- 产品信息 -->
      <div class="stTitle"><a><img src="/static/images/pesticide/icon_01.png"></a><a>产品信息</a></div>
      <div>
        <ul class="stMain">
          <p class="stPimg"><img :src="datas.product.img"></p>
          <li v-if="datas.code"><a>单元识别码：</a><a v-text="datas.code"></a></li>
          <li><a>登记证号：</a><a v-text="datas.product.reg_code_str"></a></li>
          <li><a>农药登记证号持有人：</a><a v-text="datas.product.reg_code_owner"></a></li>
          <li><a>产品名称：</a><a v-text="datas.product.name"></a></li>
          <li v-if="datas.product.alias_name"><a>农药名称：</a><a v-text="datas.product.alias_name"></a></li>
          <li v-if="datas.product.period"><a>保质期：</a><a v-text="datas.product.period"></a></li>
          <li v-if="datas.product.unit"><a>规格：</a><a v-text="datas.product.unit"></a></li>
          <li v-if="datas.batch.name"><a>批次号：</a><a v-text="datas.batch.name"></a></li>
          <li class="MainBoxRow" v-if="datas.product.attribute && (val.key || val.value)" v-for="val in datas.product.attribute">
            <a v-text="val.key+'：'"></a>
            <a v-text="val.value"></a>
          </li>
          <li><a>查询次数：</a><a v-text="datas.scan_count"></a></li>
          <li><a>首次查询时间：</a><a v-text="datas.scan_first_time"></a></li>
          <li><a>首次查询地点：</a><a v-text="datas.scan_first_address"></a></li>
        </ul>
      </div>

      <!-- 生产经营者 -->
      <template v-if="datas.business.rootid != '100010081' && datas.business.rootid != '100010085'">
        <div class="stTitle">
          <a><img src="/static/images/pesticide/icon_02.png"></a><a>生产经营者</a>
        </div>
        <div>
          <div>
            <ul class="stMain">
              <li><a>经营者名称：</a><a v-text="datas.business.name"></a></li>
              <li v-if="datas.business.address"><a>企业地址：</a><a v-text="datas.business.address"></a></li>
              <li v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
                <template v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")'>
                  <img class="img-box" :src="val.value" />
                </template>
                <template v-else>
                  <a v-text="val.key + '：'"></a><a v-text="val.value"></a>
                </template>
              </li>
              <li v-if="datas.business.introduce"><a>公司简介：</a><a v-text="datas.business.introduce"></a></li>
            </ul>
          </div>
        </div>
      </template>

      <!-- 经销商信息 -->
      <template v-if="datas.dealer">
        <div class="stTitle"><a><img src="/static/images/pesticide/icon_03.png"></a><a>销售信息</a></div>
        <div>
          <ul class="stMainTwo">
            <li><a>时间</a><a>发往</a></li>
            <li v-for="item in datas.dealer"><a>{{ item.date }}</a><a>{{ item.name }}</a></li>
          </ul>
        </div>
      </template>

      <!-- 地图  -->
      <template v-if="datas.dealer">
        <div class="stTitle mapBox"><a><img src="/static/images/pesticide/icon_06.png"></a><a>地图定位</a></div>
        <div class="mapBox" id="map" style="height:250px"></div>
      </template>

      <template v-if="datas.menu">
        <div class="stTitle"><a><img src="/static/images/pesticide/icon_04.png"></a><a>导航菜单</a></div>
				<div class="bottomNav_one" style="border:1px solid #d8e2f0;border-bottom:0;">

					<ul v-for="item in datas.menu" style="background-color: #eaedf1;border-bottom:1px solid #d8e2f0">
						<a :href="item.url">
							<li style="background-color: #eaedf1;"><img style="width:80%;margin:0px auto;" :src="item.icon"></li>
							<li>
								<p style="color:#000" v-text="item.name"></p>
								<p style="color:#555" v-text="item.describe"></p>
							</li>
						</a>
					</ul>

				</div>
      </template>

      <div class="stCopyright">技术支持：<a href="http://oid.plus/">温州链接科技有限公司</a></div>
    </section>
  </div>
</template>

<script>
var self;
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'PesticideDetails',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data() {
    return {
      code: null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      datas: null
    }
  },
  created() {
    self = this;
    self.code = self.GetCode();
    self.datas = JSON.parse(localStorage.getItem("wwm_pesticideDetail"));
    document.body.style.backgroundColor = "rgb(246, 250, 255)";
    console.log(self.datas);
  },
  mounted() {
    if(self.datas){
      this.ReadMap();
    }else{
      this.Loading.type = 3;
      this.Loading.txt = "内容为空，请重新扫码！";
    }
  },
  methods: {
    // 百度地图API功能
    ReadMap() {
      var map = new BMap.Map("map");    // 创建Map实例
      var marker = null, label = null, point = null;

      //定位周边经销商
      const dealer = self.datas.dealer;
      if (self.datas.dealer) {
        for (var i = 0; i < dealer.length; i++) {
          if(dealer[i].lon_lat){
            const lon_lat = dealer[i].lon_lat.split(',');
            dealer[i].longitude = lon_lat[0];
            dealer[i].latitude = lon_lat[1];
            point = new BMap.Point(dealer[i].longitude, dealer[i].latitude);
            marker = new BMap.Marker(new BMap.Point(dealer[i].longitude, dealer[i].latitude));
            label = new BMap.Label(dealer[i].name, { offset: new BMap.Size(25, 0) });
            map.addOverlay(marker);
            marker.setLabel(label);
          }
        }
        map.enableScrollWheelZoom(true);  //开启鼠标滚轮缩放
        label.setStyle({
          color: "black",
          border: '0px',
          fontSize: "11px",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "微软雅黑"
        });
        map.centerAndZoom(point, 15);  // 初始化地图,设置中心点坐标和地图级别

      } else {
        // point = new BMap.Point(114.046596, 22.671488);
        // marker = new BMap.Marker(point);
        // label = new BMap.Label("温州链接科技有限公司", { offset: new BMap.Size(-68, 25) });
      }

    }
  }
}
</script>

<style scoped>
header {
  width: 100%;
  color: #fff;
  padding: 13px 0;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  background-color: #317ef3;
}

.box {
  padding: 0px 10px;
  padding-bottom: 20px;
}

.stTitle {
  overflow: hidden;
  margin-top: 20px;
}

.stTitle a {
  display: block;
  color: #317ef3;
  float: left;
  font-size: 17px;
  line-height: 40px;
}

.stTitle img {
  display: block;
  width: 35px;
  margin-right: 5px;
}

.stMain {
  margin-top: 5px;
  background-color: #eaedf1;
  padding: 0px 5px;
  overflow: hidden;
}

.stMain li {
  font-size: 14px;
  padding: 0px 5px;
  padding-bottom: 10px;
  line-height: 23px;
  overflow: hidden;
}

.stMain li a {
  display: block;
  float: left;
}

.stMain li:first-child {
  padding-top: 10px;
}

.stMain li a:first-child {
  color: #444;
}

.stCopyright {
  font-size: 12px;
  text-align: center;
  padding: 20px 0;
}

.stCopyright a {
  color: #000;
  text-decoration: none;
}

.stMainTwo {
  margin-top: 5px;
  background-color: #eaedf1;
  border: 1px solid #d8e2f0;
}

.stMainTwo li {
  overflow: hidden;
  color: #444;
  font-size: 13px;
  border-bottom: 1px solid #d8e2f0;
}

.stMainTwo li:last-child {
  border-bottom: 0;
}

.stMainTwo li:first-child {
  color: #000;
  font-size: 14px;
}

.stMainTwo li:first-child a {
  padding: 12px 0px;
}

.stMainTwo li a {
  float: left;
  width: 49.5%;
  line-height: 24px;
  padding: 10px 0px;
  display: block;
  text-align: center;
  border-right: 1px solid #d8e2f0;
}

.stMainTwo li a:last-child {
  border-right: 0px;
}

.stPimg {
  padding: 0px 0;
  margin: 8px 5px;
}

.stPimg img {
  display: block;
  width: 100%;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/public-view/PesticideDetails.vue